import { queryFundAccMarketListAndStockPosPageList } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import storage, { StorageType } from '@/utils/storage'
import { useLazyQuery } from '@vue/apollo-composable'
import { useStore } from 'vuex'

export default function useStock() {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(queryFundAccMarketListAndStockPosPageList)

  onResult((res) => {
    const { stockPosPageList, fundAccMarketList } = res.data
    if (stockPosPageList.ok) {
      store.commit(HoldingsMutationTypes.SET_STOCK_POS_PAGE_LIST, stockPosPageList.data.rows)
    }
    if (fundAccMarketList.ok) {
      store.commit(HoldingsMutationTypes.SET_FUND_ACC_MARKET_LIST, fundAccMarketList.data[0])
    }
  })

  const queryStockData = () => {
    const param = {
      exchangeType: store.state.holdings.marketTypeActive.value,
      fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
    }
    const params = {
      stockPage: param,
      fundAcc: param
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(queryFundAccMarketListAndStockPosPageList, params) || refetch(params)
  }
  return { queryStockData, onResult, loading }
}
